<h3 mat-dialog-title>Additional Verification Required</h3>

<mat-dialog-content>
    <ng-container *ngIf="!type else confirmForm">
        Please select how you would like to verify your identity:
        <div class="grid-layout grid-2">
            <button class="btn btn-outline-secondary" [disabled]="isSendingSms" (click)="setSmsType()">
                <span *ngIf="isSendingSms">Sending code...</span>
                <span *ngIf="!isSendingSms">Text me a code</span>
            </button>
            <button class="btn btn-outline-secondary" [disabled]="isSendingSms" (click)="setGoogleType()">
                Enter authenticator app code
            </button>
        </div>
    </ng-container>
    <ng-template #confirmForm>
        <label *ngIf="type === 'sms'">Enter the code that was sent to your device:</label>
        <label *ngIf="type === 'google'">Enter the code displayed by the authenticator app:</label>
        <input class="form-control" (keydown.enter)="submit()" [formControl]="control">
        <lf-control-messages [control]="control"></lf-control-messages>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <ng-container *ngIf="!type else confirmButtons">
        <button class="btn btn-outline-secondary" mat-dialog-close>
            Cancel
        </button>
    </ng-container>
    <ng-template #confirmButtons>
        <button *ngIf="canGoBack else spacer" class="btn btn-outline-secondary" (click)="type = null">
            Back
        </button>
        <ng-template #spacer>
            <div></div>
        </ng-template>
        <button [disabled]="isSubmitting" (click)="submit()" class="btn btn-primary">
            Verify
        </button>
    </ng-template>
</mat-dialog-actions>
